import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { TogglerService } from 'src/app/components/core/_infrastructure/classes/services/toggler.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-dev',
    templateUrl: './login-dev.component.html',
    styleUrls: ['./login-cas.component.scss'],
})
export class LoginDevComponent extends ComponentBase implements OnInit, OnDestroy {
    visibilityIniciando = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private togglerService: TogglerService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnDestroy(): void {
        this.togglerService.loginPanelVisibility(false);
    }

    ngOnInit() {
        this.createForm();
        this.togglerService.loginPanelVisibility(true);
    }

    private createForm(): void {
        this.form = this.fb.group({
            IdentificadorUsuario: ['57148612Y', Validators.required],
        });
    }

    onKeydown(): void {
        this.onLogin();
    }

    onLogin(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilityIniciando = true;

        this.authService.login(this.form.value.IdentificadorUsuario, '').subscribe({
            next: res => {
                this.visibilityIniciando = false;
                if (res) {
                    this.addSuccessMessage('Sesión iniciada');
                    this.router.navigate(['/home']);
                } else {
                    this.addErrorMessage('Error de autorización');
                    this.router.navigate(['/error/loginko']);
                }
            },
            error: error => {
                this.catchServerError(error);
                this.visibilityIniciando = false;
            },
        });
    }
}
